var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberOfUnpaidInstallments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 23C29.8038 23 26 26.8038 26 31.5C26 36.1962 29.8038 40 34.5 40C39.1962 40 43 36.1962 43 31.5C43 26.8038 39.1962 23 34.5 23ZM36.625 30.82C36.625 32.1162 35.9238 33.3487 34.8188 34.0075L33.2038 34.985C32.9488 35.1338 32.6725 35.2188 32.3963 35.2188C31.865 35.2188 31.3337 34.9425 31.0362 34.4538C30.59 33.71 30.8238 32.7112 31.5888 32.265L33.2038 31.2876C33.3525 31.2026 33.4588 31.0113 33.4588 30.8413V28.865C33.4588 27.9938 34.1813 27.2713 35.0525 27.2713C35.9238 27.2713 36.6463 27.9938 36.6463 28.865V30.82H36.625Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8161 8.44894V11.4285H0V8.44894C0 3.77549 3.79595 0 8.4694 0H32.3467C37.0202 0 40.8161 3.77549 40.8161 8.44894Z",
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 11.4287V26.6531C0 31.3266 3.77552 35.1021 8.44897 35.1021H21.2244C22.4081 35.1021 23.4284 34.1021 23.3264 32.9184C23.0407 29.796 24.0407 26.4082 26.8162 23.7144C27.9591 22.5919 29.3672 21.7348 30.8978 21.245C33.4488 20.4287 35.9182 20.5307 38.1018 21.2654C39.4283 21.7144 40.8161 20.7552 40.8161 19.347V11.4287H0ZM12.2448 28.2654H8.16323C7.32649 28.2654 6.63262 27.5715 6.63262 26.7348C6.63262 25.898 7.32649 25.2042 8.16323 25.2042H12.2448C13.0816 25.2042 13.7754 25.898 13.7754 26.7348C13.7754 27.5715 13.0816 28.2654 12.2448 28.2654Z",
    fill: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 26.7347C13.7754 27.5714 13.0816 28.2653 12.2448 28.2653H8.16322C7.32649 28.2653 6.63261 27.5714 6.63261 26.7347C6.63261 25.898 7.32649 25.2041 8.16322 25.2041H12.2448C13.0816 25.2041 13.7754 25.898 13.7754 26.7347Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOfUnpaidInstallments);
export default __webpack_public_path__ + "static/media/NumberOfUnpaidInstallments.e1f3caa7a986d7390eb50dd6886c0f31.svg";
export { ForwardRef as ReactComponent };